function UserReducer(state = {
  confirmerList: [], pageFieldList: [], userList: null, userPop: '', selectedUserPop: '', unreadReminders: null, remindersCount:0
  , reminders: null
}, action) {

  switch (action.type) {

    case "FETCH_User_List":
      return {
        ...state,
        UsersList: action.data
      };
    case "PAGE_FIELD_LIST":
      return {
        ...state,
        pageFieldList: action.data
      }
    case "GET_USER_LIST":
      return {
        ...state,
        userList: action.data
      }
    case "USER_POP":
      return {
        ...state,
        userPop: action.data
      }
    case "SELECTED_USER_POP":
      return {
        ...state,
        selectedUserPop: action.data
      }
    case "SEARCH_UNREAD_REMINDERS":
      return {
        ...state,
        unreadReminders: action.data
      }
    case "SEARCH_REMINDERS":
      return {
        ...state,
        reminders: action.data
      }
      case "REMINDER_COUNT":
        return{
          ...state,
          remindersCount: action.data
        }
    default:
      return state;
  }
}

export default UserReducer;